import { useCallback } from "react";

import type * as Repository from "../repository";
import type * as Type from "../type";
import type { SearchParamsState } from "../use-case/use-search-model/use-search-params";

type Props = {
	queryData: Repository.Query.QueryData.ReservationListQueryData;
	searchParamsState: SearchParamsState;
};
type Result = {
	searchModel: Type.SearchModel;
};

export const useSearchModelConverter = () => {
	/**
	 * SearchModel へ変換
	 */
	const onConvertSearchModel = useCallback(({ queryData, searchParamsState }: Props): Result => {
		const { reservationList } = queryData;
		const plans: Array<string> = reservationList.filter(({ plan }) => !!plan).map(({ plan }) => plan ?? "");
		const rooms: Array<string> = reservationList.map(({ room }) => room.map(({ name }) => name)).flat();
		const options: Array<string> = reservationList.map(({ option }) => option.map(({ name }) => name)).flat();
		const discounts: Array<string> = reservationList
			.filter((item) => !!item.discount)
			.map((reservation) => reservation.discount ?? "");
		// 重複を削除
		const uniquePlans = Array.from(new Set(plans));
		const uniqueRooms = Array.from(new Set(rooms));
		const uniqueOptions = Array.from(new Set(options));
		const uniqueDiscounts = Array.from(new Set(discounts));
		return {
			searchModel: {
				freeWordText: "",
				isActiveChecked: searchParamsState.isActiveChecked,
				isCanceledChecked: searchParamsState.isCanceledChecked,
				isAcceptMailMagazineChecked: searchParamsState.isAcceptMailMagazineChecked,
				isLocalPaymentChecked: searchParamsState.isLocalPaymentChecked,
				isHostReservationChecked: searchParamsState.isHostReservationChecked,
				isDayTripChecked: searchParamsState.isDayTripChecked,
				/**
				 * @todo IDに商品名が設定されており重複する可能性があるので、商品が持つIDを使用する。バックエンドでGraphQLスキーマから変更する必要がある。
				 */
				reservation: {
					plans: uniquePlans.map((plan) => ({
						id: plan,
						label: plan,
						checked: searchParamsState.plans.includes(plan),
					})),
					rooms: uniqueRooms.map((room) => ({
						id: room,
						label: room,
						checked: searchParamsState.rooms.includes(room),
					})),
					options: uniqueOptions.map((option) => ({
						id: option,
						label: option,
						checked: searchParamsState.options.includes(option),
					})),
					discounts: uniqueDiscounts.map((discount) => ({
						id: discount,
						label: discount,
						checked: searchParamsState.discounts.includes(discount),
					})),
				},
			},
		} satisfies Result;
	}, []);

	return {
		onConvertSearchModel,
	};
};
